import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { EditSquare, Left } from '../../../../components/Icon';
import { HBox, VBox } from '../../../../components/Box';
import { Modal, ModalControls } from '../../../../components/Modal';
import { Button } from '../../../../components/Buttons';
import { Checkbox } from '../../../../components/Checkbox';
import { Dropdown } from '../../../../components/Dropdown';
import { Input } from '../../../../components/Input';
import { FormField } from '../../../../components/FormFields';
import { UserSelection } from '../../../Users/components/UserSelection';
import { UserLabelById } from '../../../Users/components/UserLabelById';
import { shareExcelCompanyData } from '../../actions';
import { fetchUser } from '../../../Users/actions';
import {
  BULK_ACTION_DEFAULT_EXCEL_COMPANY_DATA,
  EXPORT_IN_EXCEL_PROPERTIES_LIST_COL_1,
  EXPORT_IN_EXCEL_PROPERTIES_LIST_COL_2,
} from '../../constants';

import { VehicleCreateFieldCompany } from '../../../Vehicles/pages/create/FieldCompany';
import { VehicleCreateFieldCompanyUser } from '../../../Vehicles/pages/create/FieldCompanyUser';
import { COLOR_BG_LIGHT } from '../../../../vars';

const STATE = {
  addedProps: {},
  isAddSecondContact: false,
  download: true,
  sendToEmail: false,
  relation: null,
  contact: null,
  secondaryRelation: null,
  secondaryContact: null,
  extraEmail: null,
};

const Container = styled.div`
  font-size: 14px;
  .title {
    font-size: 14px;
  }

  .section {
    margin-bottom: 24px;
  }

  strong {
    margin-bottom: 24px;
  }

  .search-top {
    position: fixed;
    top: 0px;
    width: 100%;
    height: 90px;
    padding: 15px;
    font-weight: 600;

    background-color: ${COLOR_BG_LIGHT};

    .list-result-label {
      font-weight: 500;
      width: 50px;
      margin: 5px;
      text-align: center;
      background-color: black;
      color: #fff;
    }
  }

  .dropdown-wrapper {
    > .Dropdown-root {
      min-width: 350px;
      max-width: 768px;
    }
  }

  .mobile-btn-block {
    position: fixed;
    left: 0;
    bottom: 0;
    margin: 0;
    width: 100%;
    .modal-footer-button {
      margin: 0;
      display: flex;
      height: 70px;
      min-width: 50%;
    }
  }
`;

/* eslint-disable react/prefer-stateless-function */
class ExportCompaniesInExcelModalBaseComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    [...EXPORT_IN_EXCEL_PROPERTIES_LIST_COL_1, ...EXPORT_IN_EXCEL_PROPERTIES_LIST_COL_2].map(type => {
      if (BULK_ACTION_DEFAULT_EXCEL_COMPANY_DATA.includes(type)) {
        this.handleCheckProperty(type);
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {}

  get dto() {
    const properties = Object.keys(this.state.addedProps).filter(key => !!this.state.addedProps[key]);
    const companyIds = this.props.companyIds || [];
    let emailAddresses = [];
    ['contact', 'secondaryContact', 'extraEmail'].map(key => {
      if (this.state[key]?.email) {
        emailAddresses.push(this.state[key]?.email);
      }
    });

    if (this.state.manualExtraEmail) {
      emailAddresses.push(this.state.manualExtraEmail);
    }

    return {
      ids: companyIds,
      properties: properties || [],
      addresses: emailAddresses,
    };
  }

  reset() {
    this.setState({ ...STATE });
  }

  handleCheckProperty(type) {
    if (this.state.addedProps[type]) {
      this.setState(prev => ({
        addedProps: { ...prev.addedProps, [type]: false },
      }));
      return;
    }
    this.setState(prev => ({
      addedProps: { ...prev.addedProps, [type]: true },
    }));
  }

  downloadCheck() {
    if (this.state.download) {
      return;
    }
    this.setState({
      download: true,
      sendToEmail: false,
      relation: null,
      contact: null,
      secondaryRelation: null,
      secondaryContact: null,
      extraEmail: null,
      manualExtraEmail: '',
      preselectionValue: null,
    });
  }

  sendToEmailCheck() {
    if (this.state.sendToEmail) {
      return;
    }
    this.setState({ download: false, sendToEmail: true });
  }

  save() {
    this.props.shareExcel(this.dto, res => {
      if (res?.type == 'Buffer') {
        var blob = new Blob([new Buffer(res.data)], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,',
        });
        var objectUrl = URL.createObjectURL(blob);
        window.open(objectUrl);
      }
    });
    return this.props.reset();
  }

  renderContactSelection(isShow, relationKey, contactKey) {
    if (!isShow) return;

    return (
      <FormField label={this.lbl('vehicle.overview.excel_modal.select_relation')}>
        <VehicleCreateFieldCompany
          key={relationKey}
          title={'select_relation'}
          onChange={value => this.setState({ [relationKey]: value, [contactKey]: null, loading: true })}
          selectedCompanyId={this.state[relationKey]}
        />
      </FormField>
    );
  }

  renderUserSelection(isShow, relationKey, contactKey) {
    if (!isShow) return;
    return (
      <FormField className="section" label={this.lbl('vehicle.overview.excel_modal.select_contact')}>
        <VehicleCreateFieldCompanyUser
          key={contactKey}
          title={'select_contact'}
          onChange={value => {
            this.props.fetchUser(value, result => {
              this.setState({
                [contactKey]: {
                  userId: result?.id,
                  email: result?.email_address,
                },
              });
            });
          }}
          companyId={this.state[relationKey]}
          selectedCreditorId={this.state[contactKey]?.userId}
        />
      </FormField>
    );
  }

  selectUser(user) {
    if (user?.id) {
      this.props.fetchUser(user?.id, result => {
        this.setState({
          extraEmail: {
            userId: result?.id,
            email: result?.email_address,
          },
          manualExtraEmail: '',
        });
      });
    }
    this.reset();
  }
  reset() {
    this.setState({ selectUser: false, addUser: null });
  }

  renderAddUser() {
    if (!this.state.selectUser) return null;

    return (
      <Modal title={this.lbl('company.users.delete.confirm.title')}>
        {this.state.addUser?.id ? (
          <VBox>{this.state.addUser?.email_address}</VBox>
        ) : (
          <UserSelection onSelect={user => this.setState({ addUser: user })} />
        )}

        <ModalControls>
          <Button disabled={!this.state.addUser?.id} onClick={() => this.selectUser(this.state.addUser)}>
            {this.lbl('add')}
          </Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  render() {
    return (
      <Container>
        <HBox>
          {window.innerWidth <= 768 && (
            <HBox vCenter left className="search-top">
              <Left />
              {this.lbl('vehicle.overview.excel_card.share_data')}
              <p className="list-result-label">{this.props.companyIds?.length}</p>
            </HBox>
          )}
          <Modal
            mobileView={this.props.mobileView}
            mediumWide
            onClose={this.props.reset}
            title={this.lblStr('vehicle.order.add_outgoing_order')}
          >
            {this.renderAddUser()}
            {!this.props.mobileView && (
              <HBox className="section">
                <VBox>
                  {EXPORT_IN_EXCEL_PROPERTIES_LIST_COL_1.map(type => (
                    <FormField key={type}>
                      <Checkbox onChange={() => this.handleCheckProperty(type)} checked={this.state.addedProps[type]}>
                        {this.lbl(`vehicle.property.${type}`)}
                      </Checkbox>
                    </FormField>
                  ))}
                </VBox>
                <VBox>
                  {EXPORT_IN_EXCEL_PROPERTIES_LIST_COL_2.map(type => (
                    <FormField key={type}>
                      <Checkbox onChange={() => this.handleCheckProperty(type)} checked={this.state.addedProps[type]}>
                        {this.lbl(`vehicle.property.${type}`)}
                      </Checkbox>
                    </FormField>
                  ))}
                </VBox>
              </HBox>
            )}

            {this.props.mobileView && (
              <VBox className="section">
                {EXPORT_IN_EXCEL_PROPERTIES_LIST_COL_1.map(type => (
                  <FormField key={type}>
                    <Checkbox onChange={() => this.handleCheckProperty(type)} checked={this.state.addedProps[type]}>
                      {this.lbl(`vehicle.property.${type}`)}
                    </Checkbox>
                  </FormField>
                ))}

                {EXPORT_IN_EXCEL_PROPERTIES_LIST_COL_2.map(type => (
                  <FormField key={type}>
                    <Checkbox onChange={() => this.handleCheckProperty(type)} checked={this.state.addedProps[type]}>
                      {this.lbl(`vehicle.property.${type}`)}
                    </Checkbox>
                  </FormField>
                ))}
              </VBox>
            )}

            <VBox>
              <strong>
                {this.lbl('download')} / {this.lbl('send_to_email')}
              </strong>
              <FormField>
                <Checkbox onChange={this.downloadCheck.bind(this)} checked={this.state.download}>
                  {this.lbl(`download`)}
                </Checkbox>
              </FormField>
              <FormField>
                <Checkbox onChange={this.sendToEmailCheck.bind(this)} checked={this.state.sendToEmail}>
                  {this.lbl(`send_to_email`)}
                </Checkbox>
              </FormField>
              {this.renderContactSelection(this.state.sendToEmail, 'relation', 'contact')}

              {!this.state.loading && this.renderUserSelection(this.state.sendToEmail, 'relation', 'contact')}

              {this.renderContactSelection(this.state.isAddSecondContact, 'secondaryRelation', 'secondaryContact')}

              {!this.state.loading &&
                this.renderUserSelection(this.state.isAddSecondContact, 'secondaryRelation', 'secondaryContact')}
              {this.state.sendToEmail && (
                <Button
                  warning={this.state.isAddSecondContact}
                  onClick={() => {
                    if (this.state.isAddSecondContact) {
                      this.setState({ isAddSecondContact: false, secondaryContact: null, secondaryRelation: null });
                      return;
                    }
                    this.setState({ isAddSecondContact: true });
                  }}
                >
                  {this.state.isAddSecondContact
                    ? this.lbl('vehicle.overview.excel_modal.remove_extra_contact')
                    : this.lbl('vehicle.overview.excel_modal.add_extra_contact')}
                </Button>
              )}

              {this.state.sendToEmail && <strong>{this.lbl('vehicle.overview.excel_modal.add_extra_email')}</strong>}
              {this.state.sendToEmail && (
                <HBox left>
                  <FormField style={{ width: '50%' }}>
                    <Input
                      type="email"
                      name="email"
                      value={this.state.manualExtraEmail}
                      onChange={evt => this.setState({ manualExtraEmail: evt.target.value, extraEmail: null })}
                      rightDecoration={
                        <HBox>
                          <UserLabelById order user_id={this.state.extraEmail?.userId} key={this.state.extraEmail} />
                          <Button small onClick={() => this.setState({ selectUser: true })}>
                            <EditSquare />
                          </Button>
                        </HBox>
                      }
                    />
                  </FormField>
                </HBox>
              )}
            </VBox>

            {this.props.mobileView && (
              <ModalControls className="mobile-btn-block" style={{ backgroundColor: '#fff' }}>
                <Button className="modal-footer-button" onClick={this.props.reset}>
                  {this.lbl(`cancel`)}
                </Button>
                <Button className="modal-footer-button" primary type="submit" onClick={this.save.bind(this)}>
                  {this.lbl(`confirm`)}
                </Button>
              </ModalControls>
            )}

            {!this.props.mobileView && (
              <ModalControls style={{ justifyContent: 'end' }}>
                <Button small onClick={this.props.reset}>
                  {this.lbl(`cancel`)}
                </Button>
                <Button small primary type="submit" onClick={this.save.bind(this)}>
                  {this.lbl(`confirm`)}
                </Button>
              </ModalControls>
            )}
          </Modal>
        </HBox>
      </Container>
    );
  }
}

ExportCompaniesInExcelModalBaseComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchUser(userId, callback) {
      dispatch(fetchUser(userId, callback));
    },
    shareExcel(dto, callback) {
      dispatch(shareExcelCompanyData(dto, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ExportCompaniesInExcelModalBase = compose(
  withConnect,
  withRouter,
  injectIntl,
)(ExportCompaniesInExcelModalBaseComp);
